import {faCheck} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Item, ItemIndicator, ItemText} from '@radix-ui/react-select';
import clsx from 'clsx';

// TODO: set max ItemText width dynamically with css vars

type Props = React.ComponentPropsWithRef<typeof Item>;
export const SelectItem = (
  {
    ref: forwardedRef,
    className,
    children,
    ...props
  }: Props & {
    ref?: React.RefObject<HTMLDivElement>;
  }
) => {
  const cn = clsx(
    'relative cursor-default select-none py-2 pl-3 pr-9 focus:outline-hidden radix-highlighted:bg-blue10 radix-highlighted:font-semibold radix-highlighted:text-white radix-state-checked:font-semibold',
    className
  );

  return (
    <Item {...props} ref={forwardedRef} className={cn}>
      <ItemText>
        <span className="flex max-w-md items-center truncate">
          {children}
        </span>
      </ItemText>

      <ItemIndicator className="absolute inset-y-0 right-0 flex items-center pr-4">
        <FontAwesomeIcon
          icon={faCheck}
          className="h-3 w-3"
          aria-hidden="true"
        />
      </ItemIndicator>
    </Item>
  );
};

SelectItem.displayName = 'SelectItem';
